import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sortedIds: [],
  entities: {},
  filters: {},
  sorter: {},
  isLoaded: false,
  isSavingActive: false,
  search: '',
  page: 1,
  pageCount: 1,
  selectedAd: null,
  sources: [],
  isSourcesLoaded: false,
  categories: [],
  isCategoriesLoaded: false,
  imagePreview: {
    icon: null,
    hero: null,
  },
  affiliateNetworks: [],
  isNetworksLoaded: false,
  isConverting: false,
  convertedUrl: null,
  converterError: null,
}

const arcAdsSlice = createSlice({
  name: 'arcAds',
  initialState,
  reducers: {
    fetchArcAdsSuccess: (state, { payload }) => {
      // Normalize entities by ID
      const entities = {}
      payload.ads.forEach(ad => {
        entities[ad.id] = ad
      })
      return {
        ...state,
        isLoaded: true,
        page: payload.page,
        pageCount: payload.pageCount,
        entities,
        included: payload.included,
        sortedIds: payload.sortedIds,
      }
    },
    fetchArcAdsFailure: (state) => state,
    fetchArcAdDetailsSuccess: (state, { payload }) => ({
      ...state,
      selectedAd: payload.ad,
      included: payload.included || state.included || [],
    }),
    fetchArcAdDetailsFailure: (state) => ({
      ...state,
      selectedAd: null,
    }),
    fetchArcAdSourcesSuccess: (state, { payload }) => ({
      ...state,
      sources: payload.sources,
      isSourcesLoaded: true,
    }),
    fetchArcAdSourcesFailure: (state) => ({
      ...state,
      sources: [],
      isSourcesLoaded: false,
    }),
    fetchArcCategoriesSuccess: (state, { payload }) => ({
      ...state,
      categories: payload.categories,
      isCategoriesLoaded: true,
    }),
    fetchArcCategoriesFailure: (state) => ({
      ...state,
      categories: [],
      isCategoriesLoaded: false,
    }),
    saveFiltersAndSorter: (state, { payload = {} }) => ({
      ...state,
      search: payload.search,
      filters: payload.filters || initialState.filters,
      sorter: payload.sorter || initialState.sorter,
    }),
    startSaving: (state) => ({
      ...state,
      isSavingActive: true,
    }),
    finishSaving: (state) => ({
      ...state,
      isSavingActive: false,
    }),
    setImagePreview: (state, { payload }) => ({
      ...state,
      imagePreview: {
        ...state.imagePreview,
        [payload.type]: payload.url,
      },
    }),
    clearImagePreview: (state, { payload }) => ({
      ...state,
      imagePreview: {
        ...state.imagePreview,
        [payload.type]: null,
      },
    }),
    updateArcAdSuccess: (state, { payload }) => {
      if (payload.data && payload.data.id) {
        return {
          ...state,
          entities: {
            ...state.entities,
            [payload.data.id]: payload.data,
          },
        }
      }
      return state
    },
    updateArcAdFailure: (state) => state,
    fetchAffiliateNetworksSuccess: (state, { payload }) => ({
      ...state,
      affiliateNetworks: payload.networks,
      isNetworksLoaded: true,
    }),
    fetchAffiliateNetworksFailure: (state) => ({
      ...state,
      affiliateNetworks: [],
      isNetworksLoaded: false,
    }),
    startConverting: (state) => ({
      ...state,
      isConverting: true,
      converterError: null,
    }),
    finishConverting: (state) => ({
      ...state,
      isConverting: false,
    }),
    convertClickUrlSuccess: (state, { payload }) => ({
      ...state,
      convertedUrl: payload.convertedUrl,
      converterError: null,
    }),
    convertClickUrlFailure: (state, { payload }) => ({
      ...state,
      convertedUrl: null,
      converterError: payload.error,
    }),
    clearConvertedUrl: (state) => ({
      ...state,
      convertedUrl: null,
      converterError: null,
    }),
    clearData: () => initialState,
  },
})

export default arcAdsSlice